import { useStyle } from "@/context/StyleContext";
import React from "react";

const DefaultButton = (
  props: React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > & { containerStyle?: React.CSSProperties; nouppercase?: boolean }
) => {
  const { colors, theme, typographyClasses } = useStyle();
  const { children, style, containerStyle, ...rest } = props;
  return (
    <div style={containerStyle}>
      <button
        className={typographyClasses["p"].className}
        style={{
          ...{
            fontWeight: 700,
            color: colors[theme].buttons.default.text,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "12px 28px",
            columnGap: "10px",
            backgroundColor: colors[theme].buttons.default.background,
            border: `none`,
            borderTopRightRadius: "16px",
            borderBottomLeftRadius: "16px",
            boxShadow: "0px 1px 1px 4px rgba(0, 0, 0, 0.1)",
            textTransform: props.nouppercase ? "none" : "uppercase",
            cursor: "pointer",
          },
          ...style,
        }}
        {...rest}
      >
        {props.children}
      </button>
    </div>
  );
};

export default DefaultButton;
